// Audio YouTube Players

window.SiteReady(($) => {
  console.log('Init: Audio');

  let GUID = 0;
  let ICONS = {
    play: `<svg fill="#fff" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
  <path d="M175 .024V1920l1570.845-959.927z" fill-rule="evenodd"/>
</svg>`,
    pause: `<svg fill="#fff" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
  <path d="M754.571 0v1920H206V0h548.571Zm960 0v1920H1166V0h548.571Z" fill-rule="evenodd"/>
</svg>`,
    audio_on: `<svg fill="#fff" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
  <path d="M1129.432 113v1694.148H903.545l-451.772-451.773V564.773L903.545 113h225.887Zm542.545 248.057C1832.017 521.097 1920 733.882 1920 960.107c0 226.226-87.983 438.898-248.023 598.938l-79.851-79.85c138.694-138.582 214.93-323.018 214.93-519.087 0-196.183-76.236-380.506-214.93-519.2ZM338.83 564.773v790.602H169.415C75.672 1355.375 0 1279.703 0 1185.96V734.187c0-93.742 75.672-169.414 169.415-169.414H338.83Zm1093.922 36.085c95.776 97.018 148.407 224.644 148.407 359.16 0 134.628-52.631 262.253-148.407 359.272l-80.303-79.174c74.656-75.897 115.767-175.4 115.767-280.099 0-104.585-41.111-204.088-115.767-279.986Z" fill-rule="evenodd"/>
</svg>`,
    audio_off: `<svg fill="#fff" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
  <path d="M1129.433 113v1694.15H903.547l-451.774-451.773V564.773L903.547 113h225.886ZM338.83 564.773v790.604H169.415c-92.806 0-167.9-74.166-169.392-166.609L0 1185.962V734.188c0-92.805 74.166-167.9 166.608-169.392l2.807-.023H338.83ZM1789.951 635 1920 764.926 1724.988 959.94 1920 1154.95 1789.951 1285l-194.89-195.012L1400.05 1285 1270 1154.951l195.012-195.012L1270 764.926 1400.049 635l195.012 195.012L1789.951 635Z" fill-rule="evenodd"/>
</svg>`,
  };

  //

  window.addEventListener('message', function(e) {
    if (e.origin !== 'https://www.youtube.com') {
      return;
    }

    try {
      let data = JSON.parse(e.data);
      let $target = getSourcePlayer(e);

      if (!$target.length) {
        return;
      }

      if (data.event == 'onReady') {
        playerReady($target, data);
      }

      if (data.event == 'initialDelivery' || data.event == 'infoDelivery') {
        playerInfoDelivery($target, data);
      }

      if (data.event == 'onStateChange') {
        playerInfoDelivery($target, data);
      }
    } catch(err) {
      console.log(err);
    }
  });

  //

  function secondsToTime(s) {
    let secs = Math.floor(Number(s));

    // let hours = Math.floor(secs / 3600);
    // let minutes = Math.floor((secs % 3600) / 60);
    let minutes = Math.floor((secs / 60));
    let seconds = secs % 60;

    let pad = (num) => num.toString().padStart(2, '0');

    // return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    return `${pad(minutes)}:${pad(seconds)}`;
  }

  //

  function getSourcePlayer(e) {
    let $iframes = $('.js-audio_player .js-iframe');
    let $target = null;

    $iframes.each((index, el) => {
      let $el = $(el);

      if ($el[0].contentWindow == e.source) {
        $target = $el.parents('.js-audio_player');
      }
    });

    return $target;
  }

  //

  function playerLoaded($target) {
    let data = $target.data('audioPlayer');

    if (typeof data !== 'undefined') {
      subscribe(data.$iframe);
    }
  }

  function playerReady($target, ytData) {
    let data = $target.data('audioPlayer');

    if (typeof data !== 'undefined') {
      data.$player.removeClass('loading');

      data.$player.on('click', '.js-play', (e) => {
        playAudio(data.$iframe);
      });

      data.$player.on('click', '.js-pause', (e) => {
        pauseAudio(data.$iframe);
      });

      data.$player.on('click', '.js-mute', (e) => {
        muteAudio(data.$iframe);
      });

      data.$player.on('click', '.js-unmute', (e) => {
        unmuteAudio(data.$iframe);
      });

      data.$player.on('click', '.js-track', (e) => {
        let percent = (e.offsetX / data.$track.outerWidth());
        let time = data.total * percent;

        seekAudio(data.$iframe, time);
      });
    }
  }

  function playerInfoDelivery($target, ytData) {
    let data = $target.data('audioPlayer');

    if (typeof data !== 'undefined' && typeof ytData.info !== 'undefined') {
      if (typeof ytData.info.currentTime !== 'undefined') {
        data.current = ytData.info.currentTime;
      }

      if (typeof ytData.info.duration !== 'undefined') {
        data.total = ytData.info.duration;
      }

      if (typeof ytData.info.progressState !== 'undefined') {
        if (typeof ytData.info.progressState.duration !== 'undefined') {
          data.total = ytData.info.progressState.duration;
        }
      }

      if (typeof ytData.info.volume !== 'undefined') {
        if (ytData.info.volume == 0) {
          data.muted = true;
        } else {
          data.muted = false;
        }
      }

      if (typeof ytData.info == 'number') {
        if (ytData.info == 1 || ytData.info == 3) {
          data.playing = true;
        } else {
          data.playing = false;
        }
      }

      playerUpdateState(data);
    }
  }

  function playerUpdateState(data) {
    data.$timeCurrent.text(secondsToTime(data.current));
    data.$timeTotal.text(secondsToTime(data.total));

    data.$fill.css('width', ((data.current / data.total) * 100) + '%');

    if (data.playing) {
      data.$player.addClass('playing');
    } else {
      data.$player.removeClass('playing');
    }

    if (data.muted) {
      data.$player.addClass('muted');
    } else {
      data.$player.removeClass('muted');
    }
  }


  //

  function subscribe($frame) {
    $frame[0].contentWindow.postMessage(JSON.stringify({event:'listening'}), '*');
  }

  function playAudio($iframe) {
    $iframe[0].contentWindow.postMessage(JSON.stringify({event:'command',func:'playVideo',args:''}), '*');
  }

  function pauseAudio($iframe) {
    $iframe[0].contentWindow.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:''}), '*');
  }

  function muteAudio($iframe) {
    $iframe[0].contentWindow.postMessage(JSON.stringify({event:'command',func:'mute',args:''}), '*');
    $iframe[0].contentWindow.postMessage(JSON.stringify({event:'command',func:'setVolume',args:[0]}), '*');
  }

  function unmuteAudio($iframe) {
    $iframe[0].contentWindow.postMessage(JSON.stringify({event:'command',func:'unMute',args:''}), '*');
    $iframe[0].contentWindow.postMessage(JSON.stringify({event:'command',func:'setVolume',args:[100]}), '*');
  }

  function seekAudio($iframe, time) {
    $iframe[0].contentWindow.postMessage(JSON.stringify({event:'command',func:'seekTo',args:[time,true]}), '*');
  }

  //

  // // $('.js-video_swap, .js-video_modal').on('swap:activate', (e) => {
  // $('.js-video_swap').on('swap:activate', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $iframe = $target.find('.js-video_player');

  //   playVideo($iframe);

  //   $iframe.data('state', 'play');

  //   // let windowWidth = window.innerWidth;

  //   // if (windowWidth < 740) {
  //   //   document.documentElement.requestFullscreen();
  //   // }
  // }).on('swap:deactivate', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $iframe = $target.find('.js-video_player');

  //   pauseVideo($iframe);

  //   $iframe.data('state', 'pause');

  //   // if (document.fullscreenElement != null) {
  //   //   document.exitFullscreen();
  //   // }
  // });

  // $('.js-video_modal').on('click', (e) => {
  //   let $target = $(e.currentTarget);

  //   if ($target.hasClass('js-video_modal')) {
  //     $target.find('.js-video_modal_close').swap('deactivate');
  //   }
  // });

  function initAudioPlayer($target) {
    let data = $target.data('audioPlayer');

    if (typeof data == 'undefined') {
      let options = $.extend(true, {
        src: '',
        title: '',
      }, $target.data('audio-options'));

      let template = `<div class="audioplayer js-player loading">
  <iframe id="audioplayer-${GUID++}" src="about:blank" class="audioplayer_iframe js-iframe" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy" title="${options.title}"></iframe>
  <div class="audioplayer_button_set">
    <button type="button" class="audioplayer_button play js-play">
      <span class="screenreader">Play</span>
      ${ICONS.play}
    </button>
    <button type="button" class="audioplayer_button pause js-pause">
      <span class="screenreader">Pause</span>
      ${ICONS.pause}
    </button>
  </div>
  <div class="audioplayer_button_set">
    <button type="button" class="audioplayer_button mute js-mute">
      <span class="screenreader">Mute</span>
      ${ICONS.audio_on}
    </button>
    <button type="button" class="audioplayer_button unmute js-unmute">
      <span class="screenreader">Unmute</span>
      ${ICONS.audio_off}
    </button>
  </div>
  <div class="audioplayer_playhead">
    <span class="audioplayer_time current js-time_current">0:00</span>
    <span class="audioplayer_track js-track"><span></span></span>
    <span class="audioplayer_time total js-time_total">0:00</span>
  </div>
</div>`;

      $target.append(template);

      options.$player = $target.find('.js-player');
      options.$iframe = $target.find('.js-iframe');
      options.$play = $target.find('.js-play');
      options.$pause = $target.find('.js-pause');
      options.$mute = $target.find('.js-mute');
      options.$unmute = $target.find('.js-unmute');
      options.$timeCurrent = $target.find('.js-time_current');
      options.$timeTotal = $target.find('.js-time_total');
      options.$track = $target.find('.js-track');
      options.$fill = options.$track.find('span');

      options.current = 0;
      options.total = 0;
      options.playing = false;
      options.muted = true;

      options.$iframe.on('load', (e) => {
        playerLoaded($target);
      });

      $target.data('audioPlayer', options);

      options.$iframe.attr('src', options.src);

      // $iframe.on('load', (e) => {
      //   observer.observe($iframe[0]);
      // });
    }
  }

  $('.js-audio_player').each((i, el) => {
    initAudioPlayer($(el));
  });

  //

  // function observeAudioPlayers(entries) {
  //   entries.forEach(function(entry) {
  //     let $iframe = $(entry.target);
  //     let state = $iframe.data('state');

  //     if (state == 'play') {
  //       if (entry.isIntersecting && $iframe.hasClass('autoplay')) {
  //         playVideo($iframe);
  //       } else {
  //         pauseVideo($iframe);
  //       }
  //     }
  //   });
  // }

  // let observer = new IntersectionObserver(observeAudioPlayers, {
  //   root: null,
  //   rootMargin: '0px 0px 0px 0px',
  //   threshold: 0.1
  // });

  // $('.js-video_swap iframe').each((i, el) => {
  //   observer.observe(el);
  // });

  // $('.js-video_audio_control').on('click', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $iframe = $target.prev('iframe');
  //   let audio = $iframe.data('audio');

  //   if (!audio) {
  //     audio = 'off';
  //   }

  //   if (audio == 'off') {
  //     unmuteVideo($iframe);

  //     $iframe.data('audio', 'on');
  //   } else {
  //     muteVideo($iframe);

  //     $iframe.data('audio', 'off');
  //   }
  // });

});
